import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormYesNo, type FormYesNoProps } from "../fields/FormYesNo";
import type { FormComponentProps } from "../types";

export type FormYesNoComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> & Omit<FormYesNoProps<TFieldValues>, "control">;

export const FormYesNoComponent = <TFieldValues extends FieldValues>(
	props: FormYesNoComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormYesNo control={control} {...restProps} />
		</FormComponent>
	);
};
